<div class="modal-backdrop" (click)="onClose()"></div>

<div class="modal-dialog" (click)="$event.stopPropagation()">
  <div class="modal-content">
    <!-- Header -->
    <div class="modal-header">
      <h3 class="modal-title">Add to Watch View</h3>
      <button type="button" class="btn-close" (click)="onClose()" aria-label="Close"></button>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <!-- Tabs -->
      <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
          <a 
            class="nav-link" 
            [class.active]="activeTab === 'cameras'"
            (click)="setTab('cameras')"
            role="button">
            <i class="bi bi-camera-video"></i> Cameras
            <span *ngIf="loadingCameras" class="spinner-border spinner-border-sm ms-2"></span>
          </a>
        </li>
        <li class="nav-item">
          <a 
            class="nav-link" 
            [class.active]="activeTab === 'incidents'"
            (click)="setTab('incidents')"
            role="button">
            <i class="bi bi-exclamation-triangle"></i> Incidents
            <span *ngIf="loadingIncidents" class="spinner-border spinner-border-sm ms-2"></span>
          </a>
        </li>
        <li class="nav-item">
          <a 
            class="nav-link" 
            [class.active]="activeTab === 'statuses'"
            (click)="setTab('statuses')"
            role="button">
            <i class="bi bi-filter-circle"></i> Status Groups
            <span *ngIf="loadingStatuses" class="spinner-border spinner-border-sm ms-2"></span>
          </a>
        </li>
      </ul>

      <!-- Selection Info -->
      <div class="selection-info alert alert-info">
        <i class="bi bi-info-circle"></i>
        Selected: <strong>{{ selectedCount }}</strong> / Available slots: <strong>{{ availableSlots }}</strong>
      </div>

      <!-- Search -->
      <div class="search-box mb-3">
        <input 
          type="text" 
          class="form-control" 
          placeholder="Search..." 
          [(ngModel)]="searchTerm">
        <i class="bi bi-search search-icon"></i>
      </div>

      <!-- Cameras Tab -->
      <div *ngIf="activeTab === 'cameras'" class="tab-content-area">
        <!-- Loading -->
        <div *ngIf="loadingCameras" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading cameras...</span>
          </div>
          <p class="mt-3">Loading cameras...</p>
        </div>

        <!-- Error -->
        <div *ngIf="errorCameras && !loadingCameras" class="alert alert-danger">
          <i class="bi bi-exclamation-triangle"></i> Failed to load cameras. Please try again.
        </div>

        <!-- Camera List -->
        <div *ngIf="!loadingCameras && !errorCameras" class="item-list">
          <div *ngIf="filteredCameras.length === 0" class="empty-message">
            No cameras found.
          </div>

          <div 
            *ngFor="let selectableCamera of filteredCameras"
            class="item-card"
            [class.selected]="selectableCamera.selected"
            [class.disabled]="!canSelectMore() && !selectableCamera.selected"
            [class.already-added]="isCameraAlreadyAdded(selectableCamera.camera)"
            (click)="!isCameraAlreadyAdded(selectableCamera.camera) && toggleCamera(selectableCamera)">
            
            <div class="item-checkbox">
              <input 
                type="checkbox" 
                [checked]="selectableCamera.selected"
                [disabled]="(!canSelectMore() && !selectableCamera.selected) || isCameraAlreadyAdded(selectableCamera.camera)"
                (change)="!isCameraAlreadyAdded(selectableCamera.camera) && toggleCamera(selectableCamera)"
                (click)="$event.stopPropagation()">
            </div>
            
            <div class="item-info">
              <div class="item-name">
                <i class="bi bi-camera-video me-2"></i>
                {{ selectableCamera.camera.name || 'Unnamed Camera' }}
              </div>
              <div class="item-meta">
                <span *ngIf="selectableCamera.camera.siteUri" class="me-3">
                  <i class="bi bi-geo-alt"></i> {{ selectableCamera.camera.siteUri }}
                </span>
                <span *ngIf="selectableCamera.camera.offline" class="badge bg-warning">
                  Offline
                </span>
                <span *ngIf="isCameraAlreadyAdded(selectableCamera.camera)" class="badge bg-secondary">
                  Already Added
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Incidents Tab -->
      <div *ngIf="activeTab === 'incidents'" class="tab-content-area">
        <!-- Loading -->
        <div *ngIf="loadingIncidents" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading incidents...</span>
          </div>
          <p class="mt-3">Loading incidents...</p>
        </div>

        <!-- Error -->
        <div *ngIf="errorIncidents && !loadingIncidents" class="alert alert-danger">
          <i class="bi bi-exclamation-triangle"></i> Failed to load incidents. Please try again.
        </div>

        <!-- Incident List -->
        <div *ngIf="!loadingIncidents && !errorIncidents" class="item-list">
          <div *ngIf="filteredIncidents.length === 0" class="empty-message">
            No active incidents found.
          </div>

          <div 
            *ngFor="let selectableIncident of filteredIncidents"
            class="item-card"
            [class.selected]="selectableIncident.selected"
            [class.disabled]="!canSelectMore() && !selectableIncident.selected"
            [class.already-added]="isIncidentAlreadyAdded(selectableIncident.incident)"
            (click)="!isIncidentAlreadyAdded(selectableIncident.incident) && toggleIncident(selectableIncident)">
            
            <div class="item-checkbox">
              <input 
                type="checkbox" 
                [checked]="selectableIncident.selected"
                [disabled]="(!canSelectMore() && !selectableIncident.selected) || isIncidentAlreadyAdded(selectableIncident.incident)"
                (change)="!isIncidentAlreadyAdded(selectableIncident.incident) && toggleIncident(selectableIncident)"
                (click)="$event.stopPropagation()">
            </div>
            
            <div class="item-info">
              <div class="item-name">
                <i class="bi bi-exclamation-triangle me-2"></i>
                {{ selectableIncident.incident.site?.name || 'Unknown Site' }}
              </div>
              <div class="item-meta">
                <span class="me-3">
                  <i class="bi bi-hash"></i> Incident {{ selectableIncident.incident.incidentId }}
                </span>
                <span *ngIf="selectableIncident.incident.status" 
                      class="badge" 
                      [style.background-color]="selectableIncident.incident.status.colour"
                      [style.color]="'#fff'">
                  {{ selectableIncident.incident.status.displayName }}
                </span>
                <span *ngIf="isIncidentAlreadyAdded(selectableIncident.incident)" class="badge bg-secondary ms-2">
                  Already Added
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Status Groups Tab -->
      <div *ngIf="activeTab === 'statuses'" class="tab-content-area">
        <!-- Loading -->
        <div *ngIf="loadingStatuses" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading status groups...</span>
          </div>
          <p class="mt-3">Loading status groups...</p>
        </div>

        <!-- Error -->
        <div *ngIf="errorStatuses && !loadingStatuses" class="alert alert-danger">
          <i class="bi bi-exclamation-triangle"></i> Failed to load status groups. Please try again.
        </div>

        <!-- Status List -->
        <div *ngIf="!loadingStatuses && !errorStatuses" class="item-list">
          <div *ngIf="statuses.length === 0" class="empty-message">
            No visible status groups found.
          </div>

          <div 
            *ngFor="let selectableStatus of statuses"
            class="item-card"
            [class.selected]="selectableStatus.selected"
            [class.disabled]="!canSelectMore() && !selectableStatus.selected"
            (click)="toggleStatus(selectableStatus)">
            
            <div class="item-checkbox">
              <input 
                type="checkbox" 
                [checked]="selectableStatus.selected"
                [disabled]="!canSelectMore() && !selectableStatus.selected"
                (change)="toggleStatus(selectableStatus)"
                (click)="$event.stopPropagation()">
            </div>
            
            <div class="item-info">
              <div class="item-name">
                <i class="bi bi-filter-circle me-2"></i>
                {{ selectableStatus.statusType.displayName }}
              </div>
              <div class="item-meta">
                <span class="text-muted">
                  {{ selectableStatus.statusType.description }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="onClose()">Cancel</button>
      <button 
        type="button" 
        class="btn btn-primary" 
        [disabled]="selectedCount === 0"
        (click)="onConfirm()">
        Add {{ selectedCount }} {{ selectedCount === 1 ? 'Item' : 'Items' }}
      </button>
    </div>
  </div>
</div>
